import _ from 'lodash';
import getPaginationHeaders from '../utils/get-pagination-headers';
import api, { host, privateClient } from '.';

const path = '/estagios';

const getBaseUrl = () => `${host}${path}`;

async function buscaEstagios(search, pagination) {
	const searchParams = _.pick(search, ['registro', 'nome', 'curso']);

	const searchQuery = Object.keys(searchParams).reduce(
		(prev, param) => {
			const value = !searchParams[param];
			if (!value) return prev;

			const prefix = !prev ? '?' : '&';
			return `${prev}${prefix}${param}=${value}`;
		},
		''
	);

	return await privateClient({
		path: `${path}/search${searchQuery}`,
		headers: getPaginationHeaders(pagination),
	});
}

async function consultaEstagioPeloRegistro(registro) {
	return await privateClient({
		path: `${path}/${registro}`,
	});
}

async function listaEstagiosPorSituacao(situacao, pagination) {
	return await privateClient({
		path: `${path}`,
		headers: {
			...getPaginationHeaders(pagination),
			situacao,
		},
	});
}

async function listaEstagios(pagination) {
	return await privateClient({
		path: `${path}`,
		headers: getPaginationHeaders(pagination, { defaultPageSize: 80 }),
	});
}

async function registraRealizacao(registro, dados) {
	return await privateClient({
		path: `${path}/${registro}/realizacao`,
		params: {
			method: 'PUT',
			body: JSON.stringify(dados),
		},
	});
}

async function prorroga(registro, dados) {
	return await privateClient({
		path: `${path}/${registro}/prorrogacao`,
		params: {
			method: 'PUT',
			body: JSON.stringify(dados),
		},
	});
}

async function encerra(registro, dados) {
	return await privateClient({
		path: `${path}/${registro}/encerramento`,
		params: {
			method: 'PUT',
			body: JSON.stringify(dados),
		},
	});
}

async function downloadTCE(registro) {
	return fetch(`${api.termosDeCompromisso.getBaseUrl()}/${registro}/baixar`, {
		headers: {
			Authorization: `Bearer ${api.auth.accessToken()}`,
		},
	}).then(res => res.arrayBuffer());
}

async function downloadFrequencia(registro) {
	return fetch(`${getBaseUrl()}/${registro}/download/tce`, {
		headers: {
			Authorization: `Bearer ${api.auth.accessToken()}`,
		},
	}).then(res => res.arrayBuffer());
}

const estagios = {
	getBaseUrl,
	buscaEstagios,
	consultaEstagioPeloRegistro,
	listaEstagiosPorSituacao,
	listaEstagios,
	registraRealizacao,
	prorroga,
	encerra,
	downloadTCE,
	downloadFrequencia,
};

export default estagios;
